import axios from "axios";
import { baseUrl } from "../apiUrl";
import { Note, Notes, NotesCount } from "./types";
import { buildQueryString, QueryParam } from "../queryUtils";

export const getHomeSiteNotes = async (query: QueryParam): Promise<Notes> => {
  try {
    const response = await axios.get<Notes>(
      `${baseUrl}/clo-hms/homesite/notes?${buildQueryString(query)}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching home site notes:", error);
    throw error;
  }
};

export const getHomeSiteNotesCounts = async (
  query: QueryParam
): Promise<NotesCount<Note>> => {
  try {
    const response = await axios.get<NotesCount<Note>>(
      `${baseUrl}/clo-hms/homesite/notes?${buildQueryString(query)}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching home site notes:", error);
    throw error;
  }
};

export const createHomeSiteNote = async (
  note: Partial<Note>
): Promise<Note> => {
  try {
    const response = await axios.post<Note>(
      `${baseUrl}/clo-hms/homesite/notes`,
      note
    );
    return response.data;
  } catch (error) {
    console.error("Error creating home site note:", error);
    throw error;
  }
};

export const updateHomeSiteNote = async (
  updateNotes: Partial<Note>
): Promise<Note> => {
  try {
    const response = await axios.patch<Note>(
      `${baseUrl}/clo-hms/homesite/notes`,
      updateNotes
    );
    return response.data;
  } catch (error) {
    console.error("Error updating home site note:", error);
    throw error;
  }
};
